var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3593 15.8595C15.0869 16.0332 14.4927 16.1077 14.1213 15.7106C13.2299 14.8419 12.3385 13.9484 11.4471 13.0549C11.15 12.7819 10.8776 12.4841 10.6053 12.1862C10.5062 12.0621 10.4319 12.0621 10.2834 12.1614C9.24344 12.8563 8.10445 13.2286 6.86642 13.2783C5.35602 13.3279 3.94466 12.9308 2.73139 12.0125C0.60198 10.3992 -0.289402 8.23997 0.0820075 5.60914C0.453417 2.90384 2.53331 0.719755 5.15793 0.148913C5.38078 0.0992745 6.14836 0 6.42072 0C6.71785 0 7.73304 0.0992768 7.93112 0.124096C10.5557 0.645299 12.6852 2.80457 13.1309 5.46022C13.428 7.19757 13.1061 8.83564 12.1404 10.3C12.0414 10.4489 12.0661 10.5233 12.1899 10.6474C13.0318 11.4913 13.8737 12.3103 14.7155 13.179C15.1612 13.6506 15.5079 14.0477 15.7555 14.3455C15.9536 14.5937 16.1516 15.0404 15.8298 15.4375C15.706 15.5368 15.5574 15.7602 15.3593 15.8595ZM2.18666 6.67636C2.21142 9.13346 4.19227 11.119 6.64357 11.0942C9.07011 11.0694 11.0262 9.08383 11.0014 6.62673C10.9767 4.19444 8.99583 2.20891 6.59405 2.23373C4.14275 2.23373 2.18666 4.21926 2.18666 6.67636Z",
    fill: "#8A8A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.87c42d77ad832ed95dd5817bb9143cc0.svg";
export { ForwardRef as ReactComponent };